export default "__VITE_ASSET__edb16284__"